import { Box, Typography } from '@mui/material'

const DataNotFound = ({ message= "Data not found" }) => {
    return (
        <Box sx={{ textAlign: "center", p: 4 }}>
            <Typography variant="body1" color="text.secondary">
              {message}
            </Typography>
        </Box>
    )
}

export default DataNotFound
